import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const getBookingReportsList = async (payload) => {
  const payloadData = {
    status: payload?.status || '',
    dutyType: payload?.location || '',
    pageSize: payload?.pageSize || '',
    dateFrom: payload?.dateFrom || '',
    dateTo: payload?.dateTo || '',
    location: payload?.city || '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.reports.bookingReports}?page=${page}&status=${payloadData?.status}&dutyType=${payloadData?.dutyType}&pageSize=${payloadData?.pageSize}&dateTo=${payloadData?.dateTo}&dateFrom=${payloadData?.dateFrom}&location=${payloadData?.location}&parentCompanyId=${payloadData?.parentCompany}&companyId=${payloadData?.companyId}`
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getBookingMatrixReports = async (payload) => {
  const payloadData = {
    status: payload?.status || '',
    dutyType: payload?.location || '',
    pageSize: payload?.pageSize || '',
    dateFrom: payload?.dateFrom || '',
    dateTo: payload?.dateTo || '',
    location: payload?.city || '',
    parentCompany: payload?.parentCompany || '',
    companyId: payload?.companyId || '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reports.bookingMatrixReports}?isB2B=true&status=${payloadData?.status}&type=${payloadData?.dutyType}&dateTo=${payloadData?.dateTo}&dateFrom=${payloadData?.dateFrom}&location=${payloadData?.location}&parentCompanyId=${payloadData?.parentCompany}&companyId=${payloadData?.companyId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCustomerList = async (payload) => {
  const payloadData = {
    status: payload?.status || '',
    dutyType: payload?.location || '',
    pageSize: payload?.pageSize || '',
    dateFrom: payload?.dateFrom || '',
    dateTo: payload?.dateTo || '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.reports.customerReport}?page=${page}&isB2B=true&status=${payloadData?.status}&dutyType=${payloadData?.dutyType}&pageSize=${payloadData?.pageSize}&dateTo=${payloadData?.dateTo}&dateFrom=${payloadData?.dateFrom}`
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCustomerReport = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reports.customerMatrix}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getRevenueReport = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = "";
  if(data?.export){
    url = `${env}${
      API_ENDPOINT.reports.revenueReports +
      "?type=" +
      data?.location +
      '&isB2B=true'+
      '&export=true'+
      "&status=" +
      data?.status +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&location=" +
      (data?.city ? data?.city : "") +
      "&parentCompanyId=" +
      (data?.parentCompany ? data?.parentCompany : "") +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
    }`;
  } else{
   url = `${env}${
    API_ENDPOINT.reports.revenueReports +
    "?type=" +
    data?.location +
    '&isB2B=true'+
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&location=" +
    (data?.city ? data?.city : "") +
    "&parentCompanyId=" +
      (data?.parentCompany? data?.parentCompany : "") +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
  }`;}
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getRevenueMatrix = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.reports.revenueMatrix +
    "?type=" +
    data?.location +
    '&isB2B=true'+
    "&status=" +
    (data?.status ? data?.status : '') +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&location=" +
    (data?.city ? data?.city : "") +
    "&parentCompanyId=" +
      (data?.parentCompany ? data?.parentCompany : "") +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const revenueExportApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
 
  let url = `${env}${
    API_ENDPOINT.reports.revenueExportApi +
    "?type=" +
    '&isB2B=true'+
    data?.location +
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize +
    "&location=" +
    (data?.location ? data?.location : "") +
    "&export=" +
    (data?.export ? data?.export : "")+
    "&location=" +
    (data?.city ? data?.city : "") +
    "&parentCompanyId=" +
      (data?.parentCompany ? data?.parentCompany : "") +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getMisReportApi  = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = "";
  if(data?.export){
    url = `${env}${
      API_ENDPOINT.reports.misRportApi +
      "?type=" +
      data?.location +
      '&isB2B=true'+
      '&export=true'+
      "&billingType=" +
      data?.status +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&location=" +
      (data?.city ? data?.city : "")  +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
    }`;
  } else{
   url = `${env}${
    API_ENDPOINT.reports.misRportApi +
    "?type=" +
      data?.location +
      '&isB2B=true'+
      "&billingType=" +
      data?.status +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&location=" +
      (data?.city ? data?.city : "")  +
      "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
    }`;}
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getMisReportDownloadApi  = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = "";
  if(data?.export){
    url = `${env}${
      API_ENDPOINT.reports.misRportApi +
      "?type=" +
      data?.location +
      '&isB2B=true'+
      '&export=true'+
      "&billingType=" +
      data?.status +
      "&dateFrom=" +
      (data?.dateFrom ? data?.dateFrom : "") +
      "&dateTo=" +
      (data?.dateTo ? data?.dateTo : "") +
      "&location=" +
      (data?.city ? data?.city : "")  +
      "&companyId=" +
      (data?.companyId ? data?.companyId : "")
    }`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};